/*
  ld-rail.js — les deux flèches de la maison et l'animation de la jauge, sur les
  pistes rendues par `snippets/resource-list-carousel.liquid`.

  La convention (Val, 20/08/2026) : une piste qui défile se pilote à la FLÈCHE sur
  ordinateur et à la JAUGE sur téléphone, jamais les deux. Val, 21/08, sur la section
  blog de la home : « pas de jauge sur mobile », « les flèches ne sont pas
  conventionnelles ». Elles ne l'étaient pas : les flèches natives se posent en
  surimpression sur la photo, à `opacity: 0` jusqu'au survol, et restent affichées
  sur téléphone.

  Le partage des rôles : la STRUCTURE est en Liquid, dans notre fork du snippet, qui
  coupe les flèches natives et rend la jauge. Ce fichier ne fait que ce qui ne peut
  pas être statique : placer les deux flèches au-dessus de la piste, et faire avancer
  la barre. Val : « je m'en fiche que ce soit du noyau, Selvedge est censé être
  entièrement personnalisable. »

  ⚠️ Rien qui dépende de la VISIBILITÉ ne se vérifie dans une fenêtre en arrière-plan :
  le thème verrouille ses pistes par `slideshow-component:not([in-viewport])`, et
  Chrome y gèle l'IntersectionObserver. Une piste saine y paraît figée.
*/
(function () {
  'use strict';

  function fleche(sens, libelle) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ld-avis__arrow';
    b.setAttribute('aria-label', libelle);
    b.innerHTML = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor"'
      + ' stroke-width="1.6" aria-hidden="true"><path d="'
      + (sens === 'prec' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
    return b;
  }

  function poser(jauge) {
    if (jauge.dataset.ldPret === '1') return;
    var enveloppe = jauge.previousElementSibling;
    var piste = enveloppe && enveloppe.querySelector('slideshow-slides');
    if (!piste) return;
    jauge.dataset.ldPret = '1';
    var barre = jauge.querySelector('span');

    // 🔴 21/08, Val : « il y a des problèmes d'espacement ». Deux hôtes essayés avant
    // le bon, et la mesure les a départagés :
    //   la SECTION entière  → top 8398, soit 45 px AU-DESSUS du titre, donc les
    //                         flèches tombaient dans la bande de la section d'avant ;
    //   le conteneur de la piste → top 8510, soit 67 px SOUS le titre, parce que le
    //                         titre n'est pas dedans, il est son frère du dessus.
    // Le bon repère est le bloc du TITRE lui-même : il commence à sa ligne et s'arrête
    // au bord du contenu. Les flèches s'y alignent comme sur le rail d'avis.
    var sec = jauge.closest('.shopify-section');
    // 10/09 : les sections du noyau (recommandations produit) rendent leur titre dans un
    // .text-block, pas un .shopify-block ; et surtout leur contenu arrive EN DIFFERE :
    // au moment de la pose, le h2 n'existe pas encore, le reperage echouait et la nav
    // retombait tout en haut de la grille (constat de Val sur la fiche produit).
    // La pose devient donc patiente : accrochage immediat si le titre est la, sinon un
    // MutationObserver re-accroche la nav des que le titre apparait.
    function chercherBloc() {
      var titre = sec && sec.querySelector('h1, h2');
      var bloc = titre && titre.closest('.shopify-block, .text-block');
      return bloc && sec.contains(bloc) ? bloc : null;
    }
    var blocTitre = chercherBloc();
    var surLeTitre = !!blocTitre;
    var hote = surLeTitre ? blocTitre : jauge.parentElement;
    if (getComputedStyle(hote).position === 'static') hote.style.position = 'relative';
    var nav = document.createElement('div');
    nav.className = 'ld-reco-nav' + (surLeTitre ? ' ld-reco-nav--titre' : '');
    if (!surLeTitre && sec && window.MutationObserver) {
      var obs = new MutationObserver(function () {
        var bloc = chercherBloc();
        if (!bloc) return;
        obs.disconnect();
        if (getComputedStyle(bloc).position === 'static') bloc.style.position = 'relative';
        nav.className = 'ld-reco-nav ld-reco-nav--titre';
        bloc.appendChild(nav);
      });
      obs.observe(sec, { childList: true, subtree: true });
    }
    var prec = fleche('prec', 'Précédent');
    var suiv = fleche('suiv', 'Suivant');
    nav.append(prec, suiv);
    hote.appendChild(nav);

    function pas() {
      var c = piste.firstElementChild;
      if (!c) return piste.clientWidth;
      var g = parseFloat(getComputedStyle(piste).columnGap) || 0;
      return c.getBoundingClientRect().width + g;
    }
    prec.addEventListener('click', function () { piste.scrollBy({ left: -pas(), behavior: 'smooth' }); });
    suiv.addEventListener('click', function () { piste.scrollBy({ left: pas(), behavior: 'smooth' }); });

    function etat() {
      var course = piste.scrollWidth - piste.clientWidth;
      // ⚠️ Sans recalcul, la premiere mesure tombe avant que les cartes aient leur
      // taille : `scrollWidth` vaut `clientWidth` et la jauge sort pleine.
      var rien = course < 8;
      jauge.hidden = rien;
      nav.hidden = rien;
      if (rien) return;
      var part = Math.min(1, piste.clientWidth / piste.scrollWidth);
      barre.style.transform = 'translateX(' + (piste.scrollLeft / course * (1 - part) * 100)
        + '%) scaleX(' + part + ')';
      prec.disabled = piste.scrollLeft <= 2;
      suiv.disabled = piste.scrollLeft >= course - 2;
    }

    piste.addEventListener('scroll', etat, { passive: true });
    window.addEventListener('resize', etat);
    window.addEventListener('load', etat);
    if ('ResizeObserver' in window) new ResizeObserver(etat).observe(piste);
    etat();
  }

  function armer() { document.querySelectorAll('[data-ld-jauge-noyau]').forEach(poser); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armer);
  else armer();
  document.addEventListener('shopify:section:load', armer);
})();
